import { Component, ViewEncapsulation } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { ButtonConfig } from "../../../design-system/button/button.modal";
import { ButtonComponent } from "../../../design-system/button/button.component";
import { ICONS } from "../../../../_helpers/icons.constants";

@Component({
  selector: 'buttons-renderer',
  templateUrl: './buttons-renderer.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonComponent]
})

export class ButtonsRendererComponent implements ICellRendererAngularComp {
  actionButtons: any[] = [];
  params: ICellRendererParams;
  ICONS = ICONS;
  buttonConfig: ButtonConfig[] = [{
    id: '',
    label: '',
    color: 'primary',
    size: 'sm',
    disabled: false,
    icon: '',
    iconPosition: 'left'
  }];

  onUserAction(action) {
    this.params.data.userAction = action;
    this.params.node.setData(this.params.data);
    this.params.eGridCell.click();
  }

  initilize(params: ICellRendererParams) {
    if (params && params.data) {
      this.params = params;
      this.actionButtons = JSON.parse(JSON.stringify(params.colDef.headerComponentParams));
      for (let i = 0; i < this.actionButtons.length; i++) {
        this.actionButtons[i].disableProperty = this.actionButtons[i].disableProperty && this.params.data[this.actionButtons[i].disableProperty]
        this.actionButtons[i].hideProperty = this.actionButtons[i].hideProperty && this.params.data[this.actionButtons[i].hideProperty]
        this.buttonConfig[i] = {
          ...this.buttonConfig[i],
          id: this.actionButtons[i]?.id,
          disabled: this.actionButtons[i]?.disableProperty,
          label: this.actionButtons[i]?.buttonText,
          color: this.actionButtons[i]?.color,
          icon: this.actionButtons[i]?.icon,
          iconPosition: this.actionButtons[i]?.iconPosition
        }
      }
    }
    else {
      this.actionButtons = [];
    }
  }

  agInit(params: any): void {
    this.initilize(params);
  }

  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }

}
